import { Instance } from 'mobx-state-tree';
import { PermissionDtoModelBase } from './PermissionDtoModel.base';

/* The TypeScript type of an instance of PermissionDtoModel */
export interface PermissionDtoModelType extends Instance<typeof PermissionDtoModel.Type> {}

/* A graphql query fragment builders for PermissionDtoModel */
export { selectFromPermissionDto, permissionDtoModelPrimitives, PermissionDtoModelSelector } from './PermissionDtoModel.base';

/**
 * PermissionDtoModel
 */
export const PermissionDtoModel = PermissionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
